<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <div class="d-flex justify-space-between align-center">
        <v-text-field
          v-model="searchInput"
          required
          :label="$t('panel.adminManagement.rolesPage.searchInputLabel')"
          hide-details
          outlined
          class="theme-custom-input input-search roles-search"
          autofocus
          @input="filterRoles"
        />
        <v-btn color="primary" depressed :to="{ name: 'addRole' }" class="py-6">
          {{ $t("panel.adminManagement.rolesPage.addRoleBtn") }}
        </v-btn>
      </div>
      <v-data-table
        fixed-header
        :headers="$t('panel.adminManagement.rolesPage.table.headers')"
        :items="data"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        hide-default-footer
        :class="shortList"
      >
        <template v-slot:item.actions="{ item }">
          <router-link
            :to="{
              name: 'editRoleActions',
              params: { roleName: item.name }
            }"
            >{{
              $t("panel.adminManagement.rolesPage.table.content.detail")
            }}</router-link
          >
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { userInfoService } from "@/services";

export default {
  name: "admin-management-roles",
  data() {
    return {
      loading: false,
      tableData: [],
      searchInput: "",
      data: [],
      shortList: false
    };
  },
  async mounted() {
    await this.getAllRoles();
  },
  methods: {
    filterRoles() {
      this.data = this.tableData.filter(item =>
        new RegExp(this.searchInput, "i").test(item.name)
      );
      this.adjustTableRow(this.data.length);
    },
    getAllRoles() {
      this.loading = true;
      userInfoService
        .getAllRoles()
        .then(response => {
          this.tableData = response.data.data;
          this.adjustTableRow(this.tableData.length);
          this.data = this.tableData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    adjustTableRow(val) {
      if (val < 5 && val > 0) {
        if (val === 1) {
          this.shortList = "short-list-one-item";
        } else this.shortList = "short-list";
      } else this.shortList = "";
    }
  }
};
</script>

<style scoped lang="scss">
@import "Roles";
</style>
